import { useParams } from 'react-router-dom';
import { TFolder, useFolder } from '@modules/items';
import { StatusLabel } from '@shared/components';
import { useDocumentTitle } from '@shared/hooks';

import InlineBlockDetectionContent from '../components/inlineBlocks/InlineBlockDetectionContent';

const InlineBlockDetection = () => {
  const { productId } = useParams();
  const { error, data } = useFolder(productId);

  useDocumentTitle('Library detection');

  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading workspace..."
      error={error}
      errorMessage="Loading workspace failed!"
      render={(resolvedData) => <InlineBlockDetectionContent folder={resolvedData as TFolder} />}
    />
  );
};

export default InlineBlockDetection;
